var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-list"},[_vm._l((_vm.tabList),function(tab){return _c('div',{key:tab.id,staticClass:"tab-item",class:{ select: tab.select, hide: tab.hide },on:{"click":function($event){return _vm.select(tab)}}},[_c('div',[_vm._v(_vm._s(tab.text))])])}),_c('div',{staticClass:"operation-container"},[_vm._t("default")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }